<template>
  <div class="position-relative">
    <LoadingPlaceholder :loading="showLoadingPlaceholder"/>

    <OTPVerification v-if="meta.otp"/>

    <LoanApplication
      v-if="!showLoadingPlaceholder && !meta.otp"
      :is-authenticated="isAuthenticated"
      :has-recent-credit-sense-report="hasRecentCreditSenseReport"
      :has-mobile-number="hasMobileNumber"
    />

    <PortalTarget :multiple="false" name="steps-spinner"/>
  </div>
</template>

<script>
import store, {dispatch} from '@modules/guest/new-applicant/store/store';
import {NEW_APPLICATION} from '@store/constants';
import LoanApplication from './components/LoanApplication';
import OTPVerification from './components/OTPVerification/OTPVerification';
import SpinKit from '@components/common/SpinKit';
import Spinner from '@components/common/Spinner';
import LoadingPlaceholder from '@modules/shared/components/LoadingPlaceholder.vue';

export default {
  name: 'NewApplication',
  props: {
    code: {
      type: String,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    hasRecentCreditSenseReport: {
      type: Boolean,
      default: false,
    },
    hasMobileNumber: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    meta() {
      return store.state[NEW_APPLICATION.MODULE_NAME].meta;
    },
    showLoadingPlaceholder() {
      return this.meta.loading && (!this.meta.initialized || this.meta.otp);
    },
    // Authenticated re-applicants only skip CS bank verification when they
    // already have a CS report from the current month on file.
    skipBankVerification() {
      return this.isAuthenticated && this.hasRecentCreditSenseReport;
    },
    // Skip contact verification only when the authenticated user already has
    // a mobile number on file. If phone is null (e.g. original application
    // came through a path that missed the mobile), show ContactVerification
    // so they can provide their number before submitting.
    skipContactVerification() {
      return this.isAuthenticated; //&& this.hasMobileNumber
    },
  },
  components: {
    LoadingPlaceholder,
    Spinner,
    SpinKit,
    LoanApplication,
    OTPVerification,
  },
  created() {
    const stepsList = ['Loan Details'];

    if (!this.skipContactVerification) {
      stepsList.push('Contact Verification');
    }

    stepsList.push(
      'More About Yourself',
      'Employment Details',
      'Banking Information',
      'Review',
    );

    if (!this.isAuthenticated) {
      stepsList.push('Password');
    }

    if (!this.skipBankVerification) {
      stepsList.push('Bank Verification');
    }

    stepsList.push('Done');

    store.commit({
      type: NEW_APPLICATION.MUTATIONS.SET_STEPS_LIST,
      payload: stepsList,
    });

    dispatch({type: NEW_APPLICATION.ACTIONS.SET_CODE, payload: this.code});
    window.scrollTo({top: 0, behavior: 'smooth'});
  },
};
</script>

<style lang="scss">
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, Oxygen, sans-serif;
  background: #F4F2EC;
}

.steps-loader {
  z-index: 1111;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

@media screen and (max-width: 600px) {
  .form-control {
    color: #495057;
    border-color: #ced4da;
    border-width: 1px;
    border-radius: 0.25rem;
  }
}
</style>
